import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { formatEuro } from "../../lib/savingsFormula";
import { TrustQuotes } from "./TrustQuotes";

export const TrustAside = () => {
    const [saved, setSaved] = useState(650000);
    useEffect(() => {
        api.get("/settings/savings").then(({ data }) => data?.amount && setSaved(data.amount)).catch(() => {});
    }, []);

    return (
        <aside aria-label="Pourquoi nous faire confiance" data-testid="sim-trust-aside" className="flex-1 basis-[320px] min-w-0 lg:min-w-[320px] lg:max-w-[340px] flex flex-col gap-5">
            <div className="flex items-center gap-4">
                <div className="flex shrink-0">
                    <img src="/team/edina-berisha.jpg" alt="Edina Berisha" width={64} height={64} className="w-16 h-16 rounded-full object-cover border-2 border-sand" />
                    <img src="/team/hugo-daugeron-mijoin.jpg" alt="Hugo Daugeron-Mijoin" width={64} height={64} className="w-16 h-16 rounded-full object-cover border-2 border-sand -ml-2" />
                </div>
                <p className="m-0 text-[15px] leading-normal text-navy">
                    <strong className="font-bold">Analysé par Edina &amp; Hugo</strong>, anciens banquiers chez BNP Paribas, au sein du groupe Crédit Agricole et du groupe BPCE.
                </p>
            </div>
            <div className="flex items-center justify-between gap-4 px-5">
                <span className="text-sm leading-snug text-grey-text max-w-[110px]">Économie moyenne constatée</span>
                <span className="text-2xl font-bold text-gold-text whitespace-nowrap">55 % des frais</span>
            </div>
            <TrustQuotes />
            <div className="bg-navy text-cream rounded-xl p-5 flex flex-col gap-1">
                <span className="text-xs font-semibold uppercase tracking-[0.14em] text-gold">Déjà économisés</span>
                <span className="text-[34px] font-bold leading-tight tabular-nums" data-testid="sim-saved-counter">{formatEuro(saved)}</span>
                <span className="text-sm text-on-navy-soft">par an pour nos clients PME et ETI</span>
            </div>
        </aside>
    );
};
